import "../css/style.scss"

import MainNavigation from "./vendor/MainNavigation"
import LazyLoader from "./vendor/lazyload"
import Init from "./modules/init"

const init = new Init()

 